<template>
  <div class="candidate-info-card">
    <div class="card-head">
      <el-checkbox
        v-if="showCheckbox"
        class="head-checkbox"
        :value="isChecked && !isAgencyUploadedAndHid"
        :disabled="isAgencyUploadedAndHid"
        @change="onCheckboxChange"
      ></el-checkbox>
      <div v-if="showAppliedJob" class="info-container job">
        <span class="info-label">{{$t(`${i18nPrefix}.label.job`)}}:</span>
        <el-tooltip
          effect="light"
          popper-class="light-tooltip-popper"
          :content="appliedJob"
        >
          <span class="info">{{ appliedJob }}</span>
        </el-tooltip>
      </div>
      <div v-if="showAppliedDate" class="info-container applied-date">
        <span class="info-label">{{$t(`${i18nPrefix}.label.appliedDate`)}}:</span>
        <span class="info">{{ appliedDate|formatDate }}</span>
      </div>
      <div v-if="showJoinDate" class="info-container applied-date">
        <span class="info-label">{{$t(`${i18nPrefix}.label.joinedStartTimeJoinedEndTime`)}}:</span>
        <span class="info">{{ joinDate|formatDate }}</span>
      </div>
      <div v-if="showChannel" class="info-container channel">
        <span class="info-label">{{$t(`${i18nPrefix}.label.sourceChannel`)}}:</span>
        <el-tooltip
          effect="light"
          popper-class="light-tooltip-popper"
          :content="channel || $t(`${i18nPrefix}.label.weChatChannelName`)"
        >
          <span class="info">{{ channel || $t(`${i18nPrefix}.label.weChatChannelName`) }}</span>
        </el-tooltip>
      </div>
      <div v-if="showStatus" class="info-container status" :class="[disableChangeButton && 'is-disabled']" @click="onStatusClick">
        <span class="info-label">{{$t(`${i18nPrefix}.label.status`)}}:</span>
        <el-tooltip
          effect="light"
          popper-class="light-tooltip-popper"
          :content="tooltip ? tooltip : status"
        >
          <span class="info">{{ status }}</span>
        </el-tooltip>
      </div>
      <div v-if="showAiRecommendationStatus" class="info-container status ai-recommendation-status">
        <span class="info-label">{{$t(`${i18nPrefix}.label.status`)}}:</span>
        <el-tooltip
          effect="light"
          popper-class="light-tooltip-popper"
          :content="aiRecommendationStatus"
        >
          <span class="info">{{ aiRecommendationStatus }}</span>
        </el-tooltip>
      </div>
      <div v-if="showQuicklyChangeStatus" class="status-btn-container">
        <el-button v-if="tooltip" v-auto-tooltip.always="tooltip" class="status-btn reject-btn" icon="el-icon-close reject-icon" :disabled="disableChangeButton" @click="handleRejectBtnClick">{{ $t(`${i18nPrefix}.btn.reject`) }}</el-button>
        <el-button v-else class="status-btn reject-btn" icon="el-icon-close reject-icon" :disabled="disableChangeButton" @click="handleRejectBtnClick">{{ $t(`${i18nPrefix}.btn.reject`) }}</el-button>
        <el-dropdown
          ref="statusDropdown"
          class="move-forward-container"
          placement="top"
          trigger="click"
          :disabled="disableChangeButton"
        >
          <el-button v-if="tooltip" v-auto-tooltip.always="tooltip" class="status-btn move-forward-btn" :disabled="disableChangeButton">{{ $t(`${i18nPrefix}.btn.moveForward`) }}<i class="el-icon-right next-icon"></i></el-button>
          <el-button v-else class="status-btn move-forward-btn" :disabled="disableChangeButton">{{ $t(`${i18nPrefix}.btn.moveForward`) }}<i class="el-icon-right next-icon"></i></el-button>
          <template #dropdown>
            <el-dropdown-menu :append-to-body="false" class="status-dropdown">
              <el-input
                v-model="search.keyWords"
                class="status-searcher"
                prefix-icon="el-icon-search"
              >
              </el-input>
              <div class="status-list-container">
                <template v-if="searchedStatusGroupList.length > 0">
                  <div v-for="(group, index) in searchedStatusGroupList" class="list-item" :key="index">
                    <div class="list-group">{{ group.i18nName }}</div>
                    <ul class="list-children">
                      <li
                        v-for="(status, statusIndex) in group._searchedStatusList"
                        class="children-item"
                        :key="statusIndex"
                        :class="status.key === currentStatus.key && 'is-active'"
                        @click="changeStatus(status)"
                      >{{ status.i18nName }}</li>
                    </ul>
                  </div>
                </template>
                <template v-else>
                  <div class="list-item no-matched-data">{{ $t('common.message.noMatchedData') }}</div>
                </template>
              </div>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="operation-btn-list" :style="showStatus ? '' : 'margin-left: auto'">
        <el-dropdown
          v-if="!isAgencyUploadedAndHid"
          class="operation-btn operation-btn-dropdown"
          trigger="click"
          :class="disableChangeButton && 'is-disabled'"
          :disabled="disableChangeButton"
          @command="handleOperation($event)"
        >
          <i v-if="tooltip" v-auto-tooltip.always="tooltip" class="btn-icon el-icon-more"></i>
          <i v-else class="btn-icon el-icon-more"></i>
          <template #dropdown>
            <el-dropdown-menu class="no-arrow-dropdown-menu">
              <template v-for="(item, index) in operationList">
                <el-dropdown-item
                  v-if="showBtn(item, rowData)"
                  :key="index"
                  :command="item"
                >
                  <span v-if="!item.childrenMenuList">{{ item.label }}</span>
                  <el-popover
                    v-if="item.childrenMenuList"
                    placement="left"
                    v-model="item.visible"
                    trigger="hover"
                    popper-class="action-children-container"
                  >
                    <div
                      v-for="(child, childIndex) in item.childrenMenuList"
                      v-show="!child.hidden"
                      class="child-item"
                      :key="childIndex"
                      @click="handleOperation(child)"
                    >
                      {{ child.label }}
                    </div>
                    <div slot="reference">{{ item.label }}</div>
                  </el-popover>
                </el-dropdown-item>
              </template>
              </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="card-content">
      <div class="base-info">
        <div class="avatar-container-wrapper">
          <div class="avatar-container" :class="avatarClass" @click="onAvatarClick">
            <img class="avatar" :src="avatar"/>
            <i v-if="isAgencyUploadedAndHid" class="avatar-lock-icon iconfont iconLock"></i>
          </div>
          <CandidateListTagCellVue v-if="hasCRMTagPermission" is-card-list :tag-list="tagList" />
        </div>
        <div class="base-info-container">
          <el-tooltip effect="light" popper-class="light-tooltip-popper" :content="candidateName" placement="bottom">
            <div class="candidate-name" @click="onCandidateNameClick">{{ candidateName }}</div>
          </el-tooltip>
          <div class="id-icon-container">
            <span class="id-container">ID: {{ candidateId }}</span>
            <i v-if="genderIconClass" class="candidate-icon gender iconfont" :class="genderIconClass"></i>
            <el-tooltip
              v-if="showReferralIcon && (referralType === REFERRAL_TYPE.EMPLOYEE_SHARED || referralType === REFERRAL_TYPE.CANDIDATE_SHARED)"
              effect="light"
              popper-class="light-tooltip-popper"
              placement="bottom-start"
              :content="$t(`${i18nPrefix}.label.${referralType === REFERRAL_TYPE.EMPLOYEE_SHARED ? 'employeeReferral' : 'candidateReferral'}`)"
            >
              <span class="candidate-icon referral">
                <i class="iconfont iconreferral"></i>
              </span>
            </el-tooltip>
            <DuplicateCandidatePopover
              v-if="showDuplicateCandidateIcon && duplicateCandidateList && duplicateCandidateList.length > 0"
              class="candidate-icon duplicate-candidate"
              :duplicateCandidateList="duplicateCandidateList"
            >
              <DuplicateCandidateIcon :size="size"></DuplicateCandidateIcon>
            </DuplicateCandidatePopover>
            <el-tooltip
              v-if="showSubmittedIcon && (referralType === REFERRAL_TYPE.EMPLOYEE_SUBMITTED || referralType === REFERRAL_TYPE.CANDIDATE_SUBMITTED)"
              effect="light"
              popper-class="light-tooltip-popper"
              placement="bottom-start"
              :content="$t(`${i18nPrefix}.label.${referralType === REFERRAL_TYPE.EMPLOYEE_SUBMITTED ? 'employeeSubmitted' : 'candidateSubmitted'}`)"
            >
              <span  class="candidate-icon submit">
                <i class="submit-icon iconfont icona-bianzu53"></i>
                <i class="iconfont iconxingzhuang dot" :style="dotStyle"></i>
              </span>
            </el-tooltip>
            <span v-auto-tooltip.always="getCopiedFromJob()" v-if="copiedInfo" class="candidate-icon">
              <div class="is-copy-application">
                <i class="iconfont icona-bianzu53"></i>
                <i class="iconfont icona-copybuttonforcoach1 dot"></i>
              </div>
            </span>
          </div>
          <el-tooltip
            effect="light"
            popper-class="light-tooltip-popper"
            placement="bottom-start"
            :content="formatLocationSchoolAgeInfo(location, maxDegree, age)"
            class="tooltip-text"
          >
            <div v-if="location || maxDegree || age" class="location-age-container">
              <span v-if="location" class="location">{{ location }}</span>
              <span v-if="maxDegree" class="max-degree">{{ maxDegree }}</span>
              <span v-if="age" class="age">{{ $t(`admin.application.candidate.label.yearsOld`, { age }) }}</span>
            </div>
          </el-tooltip>
          <el-tooltip
            effect="light"
            popper-class="light-tooltip-popper"
            placement="bottom"
            :content="email"
          >
            <div class="email">{{ email|empty }}</div>
          </el-tooltip>
          <div class="phone">{{ phone|empty }}</div>
        </div>
      </div>
      <div class="resume-info">
        <div class="info-list work">
          <div
            v-for="(work, index) in workInfoList"
            class="info-line"
            :key="index"
          >
            <div class="line-icon-container">
              <i v-if="index === 0" class="line-icon iconfont icona-workexperience"></i>
              <span v-else class="dot-icon"></span>
              <span class="tail-line"></span>
            </div>
            <el-tooltip effect="light" popper-class="light-tooltip-popper" :content="formatEducationOrWorkInfo(work)" placement="bottom-start">
              <div class="info-container">
                <span
                  v-for="(info, infoIndex) in work.infoList"
                  class="info"
                  :key="infoIndex"
                  :class="infoIndex === work.infoList.length && 'no-hyphen'"
                >
                  {{ info }}
                </span>
                <span class="info work-time">{{ work.startDate|formatDateTime('YYYY.MM', '') }} - {{ work.endDate|formatDateTime('YYYY.MM', $t('common.label.now')) }}</span>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="info-list education">
          <div
            v-for="(education, index) in educationInfoList"
            class="info-line"
            :key="index"
          >
            <div class="line-icon-container">
              <i v-if="index === 0" class="line-icon iconfont iconeducation"></i>
              <span v-else class="dot-icon"></span>
              <span class="tail-line"></span>
            </div>
            <el-tooltip effect="light" popper-class="light-tooltip-popper" :content="formatEducationOrWorkInfo(education)" placement="bottom-start">
              <div class="info-container">
                <span
                  v-for="(info, infoIndex) in education.infoList"
                  class="info"
                  :key="infoIndex"
                  :class="infoIndex === education.infoList.length && 'no-hyphen'"
                >
                  {{ info }}
                </span>
                <span class="info education-time">{{ education.startDate|formatDateTime('YYYY.MM', $t('common.label.now')) }} - {{ education.endDate|formatDateTime('YYYY.MM', $t('common.label.now')) }}</span>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div v-if="assessmentLines?.length" class="assessment-info">
        <div
          v-for="(line, index) in assessmentLines"
          class="score-line"
          :key="index"
        >
          <el-tooltip
            effect="light"
            popper-class="light-tooltip-popper ai-resume-match-tooltip"
            placement="bottom"
            :disabled="!line.isInterviewRecommendation || !line.hasToolTip"
          >
            <template #content>
              <div v-if="line.hmDecisionList?.length">
                <div v-for="(hmInfo, hmIndex) in line.hmDecisionList" :key="hmInfo.id == null ? hmIndex : hmInfo.id">
                  {{ hmInfo.fullName }}: {{ hmInfo.decisionName }}
                </div>
              </div>
              <span v-else>{{ line.tooltipContent }}</span>
            </template>
            <div v-auto-tooltip.always="{ content: line.tooltipContent, disabled: line.isInterviewRecommendation || !line.hasToolTip }" class="info-line">
              <div class="score">
                <div class="score-label">{{ line.label }}</div>
                <div class="score-number">{{ getAssessmentDisplayScore(line) }}</div>
              </div>
              <div class="percent-line">
                <div class="color-line" :style="{backgroundColor: line.color, width: line.score === null ? '0' : `${line.score}%`}"></div>
              </div>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { ASSESSMENT_INVITE_TYPE, REFERRAL_TYPE } from '@/constant/application'
import { getScoreColor, getJobFitScoreColor, formatJobFitScore } from '@/utils/common'
import DuplicateCandidatePopover from './duplicateCandidatePopover.vue'
import DuplicateCandidateIcon from '@/components/icon/duplicateCandidate.vue'
import { formatDateTime } from '@/components/filters'
import CandidateListTagCellVue from '@/components/candidate/candidateListTagCell.vue'
import { ROOT_COMPANY_ID } from '@/constant/company'
import { INTERVIEW_RATING_DECISION } from '@/constant/interview'
import { HM_RECOMMENDATION_DISPLAY_MAP } from '@/constant/questionnaire'
import { getI18nPropertyValue } from '@/i18n'

const RING_GRAY_COLOR = '#c3c5c9'

function generateInfoList (dataList, infoKeys, maxInfo = 3) {
  const infoList = []
  _.forEach(dataList, (data) => {
    infoList.push({
      ...data,
      _data: data,
      infoList: _.chain(infoKeys).map(key => _.get(data, key)).filter().value()
    })
    if (infoList.length >= maxInfo) {
      return false
    }
  })
  return infoList
}

export default {
  components: {
    DuplicateCandidateIcon,
    DuplicateCandidatePopover,
    CandidateListTagCellVue
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showAppliedJob: {
      type: Boolean,
      default: true
    },
    showReferralIcon: {
      type: Boolean,
      default: true
    },
    showSubmittedIcon: {
      type: Boolean,
      default: true
    },
    showDuplicateCandidateIcon: {
      type: Boolean,
      default: true
    },
    showAssessmentFit: {
      type: Boolean,
      default: false
    },
    showProblemSolvingFit: {
      type: Boolean,
      default: false
    },
    showResumeFit: {
      type: Boolean,
      default: false
    },
    showAppliedDate: {
      type: Boolean,
      default: true
    },
    showJoinDate: {
      type: Boolean,
      default: true
    },
    showChannel: {
      type: Boolean,
      default: true
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    isSelected: {
      type: Boolean,
      required: true
    },
    isNew: {
      type: Boolean,
      default: false
    },
    isEmployee: {
      type: Boolean,
      required: true
    },
    isAlumni: {
      type: Boolean,
      required: true
    },
    isAgencyUploadedAndHid: {
      type: Boolean,
      required: false
    },
    appliedJob: {
      default: null
    },
    appliedJobCompany: {
      default: null
    },
    appliedDate: {
      required: false
    },
    joinDate: {
      required: false
    },
    channel: {
      required: false
    },
    status: {
      required: false
    },
    currentStatus: {
      required: false
    },
    disableChangeButton: {
      required: false
    },
    showQuicklyChangeStatus: {
      type: Boolean,
      required: false
    },
    candidateId: {
      type: [Number, String],
      required: true
    },
    candidateName: {
      type: String,
      required: true
    },
    avatar: {
      required: true
    },
    gender: {
      default: null
    },
    referralType: {
      default: null
    },
    location: {
      default: null
    },
    maxDegree: {
      default: null
    },
    age: {
      default: null
    },
    email: {
      default: null
    },
    phone: {
      default: null
    },
    duplicateCandidateList: {
      default: null
    },
    workList: {
      default: null
    },
    internList: {
      default: null
    },
    educationList: {
      default: null
    },
    personalityFinished: {
      default: false
    },
    problemSolvingFinished: {
      default: false
    },
    cultureFit: {
      default: null
    },
    personalityFit: {
      default: null
    },
    problemFit: {
      default: null
    },
    resumeFit: {
      default: null
    },
    operationList: {
      type: Array,
      required: true
    },
    statusGroupList: {
      type: Array,
      required: false
    },
    showAiInterviewFit: {
      type: Boolean,
      default: false
    },
    aiInterviewFit: {
      required: false
    },
    tagList: {
      type: Array,
      default: null
    },
    aiResumeMatchSummary: {
      type: String,
      default: ''
    },
    copiedInfo: {
      type: Object,
      default: () => {}
    },
    showAIRecommendedFit: {
      type: Boolean,
      default: false
    },
    aiRecommendedFit: {
      required: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    aiRecommendedSummary: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: null
    },
    aiInterviewScore: {
      required: false
    },
    showAIInterviewScore: {
      default: false
    },
    showAiRecommendationStatus: {
      type: Boolean,
      default: false
    },
    aiRecommendationStatus: {
      default: null
    },
    showInterviewScore: {
      type: Boolean,
      default: false
    },
    interviewScore: {
      default: null
    },
    interviewRecommendation: {
      default: null
    },
    interviewCompletion: {
      type: [Number, String],
      default: null
    },
    interviewHmInfoList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      getI18nPropertyValue,
      REFERRAL_TYPE,
      dotColor: '#51bf82',
      size: 14,
      search: {
        keyWords: null
      }
    }
  },
  computed: {
    hasCRMTagPermission () {
      return this.hasAnyPermission('PREMIUM_TAG_MANAGEMENT')
    },
    isChecked: {
      get () {
        return this.isSelected
      },
      set (val) {
        this.$emit('update:isSelected')
      }
    },
    dotStyle () {
      const dotSize = this.dotSize ? this.dotSize : this.size * 0.6
      const style = { color: this.dotColor }
      if (dotSize >= 12) {
        style.fontSize = `${dotSize}px`
      } else {
        style.fontSize = '12px'
        style.transform = `scale(${dotSize / 12})`
      }
      return style
    },
    avatarClass () {
      const classList = []
      if (this.isNew) {
        classList.push('is-new')
      }
      if (this.isEmployee) {
        classList.push('employee')
      } else if (this.isAlumni) {
        classList.push('alumni')
      }
      return classList
    },
    genderIconClass () {
      let icon = null
      if (this.gender === 'F') {
        icon = 'iconResume-female'
      }
      if (this.gender === 'M') {
        icon = 'iconResume-male'
      }
      return icon
    },
    assessmentLines () {
      const vm = this
      const hasFinishedPersonality = this.personalityFinished
      const hasFinishedProblemSolving = this.problemSolvingFinished
      const interviewRecommendationConfig = HM_RECOMMENDATION_DISPLAY_MAP[this.interviewRecommendation]
      const hasInterviewScore = ![null, undefined, ''].includes(this.interviewScore) && Number.isFinite(Number(this.interviewScore))
      const interviewScore = hasInterviewScore ? _.round(Number(this.interviewScore)) : null
      const hasInterviewCompletion = ![null, undefined, ''].includes(this.interviewCompletion)
      const numericInterviewCompletion = hasInterviewCompletion ? Number(this.interviewCompletion) : null
      const interviewCompletion = Number.isFinite(numericInterviewCompletion) ? numericInterviewCompletion : null
      const hasInterviewResult = Boolean(interviewRecommendationConfig) || interviewScore !== null
      const isInterviewIncomplete = interviewCompletion !== null && interviewCompletion !== 100
      const interviewProgress = hasInterviewResult ? (isInterviewIncomplete ? interviewCompletion : 100) : null
      let interviewDisplayScore = interviewScore
      if (interviewScore === null) {
        interviewDisplayScore = this.interviewRecommendation === INTERVIEW_RATING_DECISION.NOT_RATE_YET ? 'N/A' : interviewRecommendationConfig?.shortLabel || '-'
      }
      const hmDecisionList = _.map(this.interviewHmInfoList, hmInfo => ({
        id: hmInfo.id,
        fullName: hmInfo.full_name,
        decisionName: this.getRecommendationDecisionName(hmInfo.rating_decision || hmInfo.interview_decision)
      }))
      const interviewDecisionName = this.getRecommendationDecisionName(this.interviewRecommendation)
      const lines = [
        {
          hidden: !this.showInterviewScore || !hasInterviewResult,
          isInterviewRecommendation: true,
          label: this.$t(`${this.i18nPrefix}.label.interviewRecommendation`),
          score: interviewProgress,
          displayScore: interviewDisplayScore,
          color: isInterviewIncomplete ? RING_GRAY_COLOR : interviewRecommendationConfig?.color || RING_GRAY_COLOR,
          hmDecisionList,
          tooltipContent: interviewDecisionName,
          hasToolTip: !_.isEmpty(hmDecisionList) || Boolean(interviewDecisionName)
        },
        {
          hidden: !this.showAssessmentFit,
          label: this.$t(`${this.i18nPrefix}.label.cultureFit`),
          score: hasFinishedPersonality ? (this.cultureFit && parseInt(this.cultureFit * 100)) : null,
          get color () {
            return getScoreColor(this.score)
          }
        },
        {
          hidden: !this.showAssessmentFit,
          label: this.$t(`${this.i18nPrefix}.label.personalityFit`),
          score: hasFinishedPersonality ? (this.personalityFit && parseInt(this.personalityFit * 100)) : null,
          get color () {
            return getScoreColor(this.score)
          }
        },
        {
          hidden: !this.showProblemSolvingFit,
          label: this.$t(`${this.i18nPrefix}.label.problemSolvingFit`),
          score: hasFinishedProblemSolving ? (this.problemFit && parseInt(this.problemFit * 100)) : null,
          get color () {
            return getScoreColor(this.score)
          }
        },
        {
          hidden: !this.showResumeFit,
          label: this.$t('admin.application.candidate.title.aiResumeMatchScore'),
          score: formatJobFitScore(this.resumeFit),
          displayScore: this.resumeFit,
          hasToolTip: this.resumeFit,
          get color () {
            return getJobFitScoreColor(vm.resumeFit)
          },
          get tooltipContent () {
            return vm.aiResumeMatchSummary
          }
        },
        {
          hidden: !this.showAIRecommendedFit,
          label: this.$t('admin.application.candidate.title.aiResumeMatchScore'),
          score: formatJobFitScore(this.aiRecommendedFit),
          displayScore: this.aiRecommendedFit,
          hasToolTip: this.aiRecommendedFit,
          get color () {
            return getJobFitScoreColor(vm.aiRecommendedFit)
          },
          get tooltipContent () {
            return vm.aiRecommendedSummary
          }
        },
        {
          hidden: !this.showAiInterviewFit,
          label: this.$t(`${this.i18nPrefix}.label.aiInterviewFit`),
          score: this.aiInterviewFit,
          get color () {
            return getScoreColor(this.score)
          }
        },
        {
          hidden: !this.showAIInterviewScore,
          label: this.$t(`${this.i18nPrefix}.label.aiInterviewScore`),
          score: this.aiInterviewScore ? parseInt(this.aiInterviewScore) : null,
          get color () {
            return getScoreColor(this.score)
          }
        }
      ]
      return _.filter(lines, item => !item.hidden)
    },
    workInfoList () {
      return generateInfoList(_.chain(this.workList).concat(this.internList).filter().value(), ['company', 'job'])
    },
    educationInfoList () {
      return generateInfoList(this.educationList, ['degree', 'school', 'major'])
    },
    isMSDCompany () {
      return this.appliedJobCompany?.root_id === ROOT_COMPANY_ID.MSD
    },
    searchedStatusGroupList () {
      const keyWords = (this.search.keyWords || '').toLowerCase()
      return _.filter(this.statusGroupList, group => {
        group._searchedStatusList = _.filter(group.status_list, status => {
          if (!status.canChangeTo) {
            return false
          }
          if (this.isMSDCompany && ['Hired', 'Disqualified'].includes(status.key)) {
            return false
          }
          if (keyWords) {
            return status.i18nName.toLowerCase().includes(keyWords)
          }
          return true
        })
        return group._searchedStatusList.length > 0
      })
    }
  },
  created () {
  },
  methods: {
    getAssessmentDisplayScore (line) {
      return ![null, undefined, ''].includes(line.displayScore)
        ? line.displayScore
        : line.score === null ? 'N/A' : line.score
    },
    getRecommendationDecisionName (decision) {
      const config = HM_RECOMMENDATION_DISPLAY_MAP[decision]
      return config
        ? this.$t(`admin.application.candidate.label.${config.i18nKey}`)
        : _.toString(decision)
    },
    getCopiedFromJob () {
      const isCopiedFromJob = this.copiedInfo.is_copied_from_job
      if (isCopiedFromJob) {
        return `${this.$t('admin.application.candidate.label.copiedFrom')}${getI18nPropertyValue(this.copiedInfo.copied_from_job, 'cn_title', 'title')} - ${this.copiedInfo.copied_from_job.id}`
      }
      return `${this.$t('admin.application.candidate.label.copiedFrom')}${this.$t('admin.talent.pool.title')}`
    },
    handleOperation (operation) {
      this.$emit('handleOperation', operation)
    },
    formatEducationOrWorkInfo (content) {
      const infoList = content.infoList.join(' · ')
      const startDate = formatDateTime(content.startDate, 'YYYY.MM', this.$t('common.label.now'))
      const endDate = formatDateTime(content.endDate, 'YYYY.MM', this.$t('common.label.now'))
      return `${infoList} ${startDate} - ${endDate}`
    },
    formatLocationSchoolAgeInfo (location, maxDegree, age) {
      const infoList = []
      if (location) {
        infoList.push(location)
      }
      if (maxDegree) {
        infoList.push(maxDegree)
      }
      if (age) {
        const ageInfo = this.$t('admin.application.candidate.label.yearsOld', { age })
        infoList.push(ageInfo)
      }
      return infoList.join(' ')
    },
    onStatusClick () {
      if (this.disableChangeButton) {
        return
      }
      this.$emit('statusClick')
    },
    onAvatarClick () {
      this.$emit('avatarClick')
    },
    onCandidateNameClick () {
      this.$emit('candidateNameClick')
    },
    onCheckboxChange (val) {
      this.$emit('selectChange', val)
    },
    handleRejectBtnClick () {
      this.$emit('toRejectStatus')
    },
    changeStatus (status) {
      if (this.currentStatus.key === status.key) {
        return
      }
      this.search.keyWords = null
      this.$emit('changeStatus', status.key)
    },
    showBtn (operation, rowData) {
      if (operation.key) {
        if (ASSESSMENT_INVITE_TYPE.PERSONALITY === operation.key) {
          return !rowData.candidate.personality_finished
        }
        if (ASSESSMENT_INVITE_TYPE.PROBLEM_SOLVING === operation.key) {
          return !rowData.candidate.problem_solving_finished
        }
      }
      if (_.has(operation, 'hidden')) {
        if (_.isFunction(operation.hidden)) {
          return !operation.hidden(rowData)
        }
        return operation.hidden
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.candidate-info-card {
  padding: 12px 20px 24px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.08);
  color: #606266;
  line-height: 20px;

  &:hover {
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.2);
    background-color: #FAFBFC;

    .card-head {
      .status-btn-container {
        display: flex;
      }
    }
  }

  .card-head {
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #e4e7ed;
    line-height: 24px;

    .head-checkbox {
      margin-right: 22px;

      ::v-deep {
        .el-checkbox__inner {
          width: 18px;
          height: 18px;

          &::after {
            height: 9px;
            left: 6px;
            top: 2px;
          }
        }
        .is-checked {
          .el-checkbox__inner {
            background-color: #0096cc;
            border-color: #0096cc;
          }
        }
      }
    }

    .info-container {

      + .info-container {
        margin-left: 24px;
      }

      .info-label {
        font-size: 12px;
        color: #606266;
      }

      .info {
        margin-left: 5px;
        color: #303133;
        font-size: 12px;
      }

      &.job, &.channel, &.status {
        .info-label {
          display: inline-block;
          vertical-align: middle;
          color: #606266;
        }

        .info {
          display: inline-block;
          font-weight: 500;
          vertical-align: middle;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      &.job {
        .info {
          max-width: 250px;
        }
      }

      &.channel {
        margin-left: 48px;

        .info {
          max-width: 110px;
        }
      }

      &.applied-date {
        .info {
          color: #606266;
          font-weight: initial;
        }
      }

      &.status {
        margin-left: 48px;

        &.is-disabled {
          .info {
            color: #c0c4cc;
            cursor: not-allowed;
          }
        }

        &.ai-recommendation-status {
          .info {
            cursor: default;
          }
        }

        .info {
          color: #0096cc;
          cursor: pointer;
          max-width: 110px;
        }
      }
    }

    .status-btn-container {
      display: none;
      margin-left: 24px;
      align-items: center;

      .status-btn {
        display: block;
        padding: 0 12px;
        color: #0096cc;
        border: 1px solid #0096cc;
        line-height: 21px;
        height: 21px;
        font-size: 12px;
        border-radius: 2px;

        &:not(.is-disabled):hover {
          color: #fff;
          background-color: #0096cc;
        }

        &.move-forward-btn {
          margin-left: 10px;
          color: #ffffff;
          background-color: #0096cc;
          border: 1px solid #0096cc;

          .next-icon {
            margin-left: 9px;
          }

          &.is-disabled {
            color: #fff;
            background-color: #c0c4cc;
            border-color: #c0c4cc;
          }
        }

        &.is-disabled {
          color: #c0c4cc;
          border-color: #ebeef5;
        }
      }

      .status-dropdown {
        width: 227px;
        padding-top: 0;

        .status-searcher {
          padding: 5px 0;
          border-bottom: 1px solid #d8dce6;

          ::v-deep .el-input__inner {
            height: 30px;
            line-height: 30px;
            border: transparent;
          }
        }

        .status-list-container {
          max-width: 209px;
          max-height: 350px;
          font-size: 14px;
          color: #606266;
          overflow: hidden auto;

          .list-item {
            .list-group {
              padding: 6px 0 6px 16px;
            }

            .list-children {
              .children-item {
                padding: 6px 0 6px 30px;
                cursor: pointer;

                &:hover {
                  background-color: #e0e0e0;
                }

                &.is-active {
                  color: #fff;
                  background-color: #0096cc;
                }
              }
            }

            &.no-matched-data {
              margin-top: 10px;
              text-align: center;
            }
          }
        }
      }
    }

    .move-forward-container {

    }
  }

    .operation-btn-list {
      margin-left: auto;
      color: #606266;
      font-weight: bold;

      .operation-btn {
        cursor: pointer;

        &.is-disabled {
          cursor: not-allowed;
          color: #c0c4cc;
        }
      }

      .btn-icon {
        transform: rotateZ(90deg);
      }
    }
  }

  .card-content {
    display: flex;
    margin-top: 24px;
    flex-direction: row;

    .base-info {
      display: flex;
      width: 303px;

      .avatar-container-wrapper {
        .avatar-container {
          position: relative;

          .avatar {
            display: block;
            width: 78px;
            height: 78px;
            padding: 1px;
            border: 1px solid transparent;
            border-radius: 50%;
            line-height: 1;
            cursor: pointer;
          }

          .avatar-lock-icon {
            position: absolute;
            top: 42px;
            right: 10px;
            font-size: 24px;
            color: #9e9e9e;
          }

          &.is-new {
            &::before {
              content: '';
              display: block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background-color: #ee7815;
              position: absolute;
              top: 0;
              left: 0;
            }
          }

          &.employee {
            .avatar {
              border-color: #0096cc;
            }
          }

          &.alumni {
            .avatar {
              border-color: #ee7815;
            }
          }
        }
      }

      .base-info-container {
        margin-left: 24px;
        width: 201px;

        > * {
          margin-top: 8px;

          &:first-child {
            margin-top: 0;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }

        .candidate-name {
          color: #303133;
          line-height: 28px;
          font-size: 15px;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          width: 201px;
          white-space: nowrap;
        }

        .email {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .id-icon-container {
          .id-container {
            margin-right: 4px;
            vertical-align: middle;
          }

          .candidate-icon {
            margin-left: 8px;
            vertical-align: middle;

            &.submit {
              position: relative;

              .submit-icon {
                font-size: 14px;
              }

              .dot {
                border-radius: 50%;
                background: #fff;
                position: absolute;
                right: -3px;
                bottom: -3px;
                line-height: 1;
                z-index: 1;
              }
            }
          }
          .gender {
            font-size: 14px;
          }
          .is-copy-application {
            position: relative;
            line-height: 1;
            display: inline-block;
            .iconfont {
              font-size: 14px;
            }

            .dot {
              font-size: 12px;
              transform: scale(0.7);
              color: #ee7815;
              border-radius: 50%;
              background: #fff;
              position: absolute;
              right: -3px;
              bottom: -3px;
              z-index: 1;
            }
          }
        }

        .location-age-container {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 201px;

          > * {
            margin-right: 10px;
          }
        }
      }
    }

    .resume-info {
      flex: 1;
      margin-left: 30px;
      overflow: hidden;

      .info-list {
        &:first-child {
          margin-bottom: 12px;
        }
        .info-line {
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          &:last-child {
            margin-bottom: 0px;

            .line-icon-container {
              .tail-line {
                display: none;
              }
            }
          }

          .line-icon-container {
            width: 14px;
            vertical-align: middle;
            text-align: center;
            position: relative;

            .line-icon {
              font-size: 14px;
              color: #c0c4cc;

              + .tail-line {
                height: 8px;
              }
            }

            .dot-icon {
              display: inline-block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background: #c0c4cc;
              vertical-align: middle;
            }

            .tail-line {
              display: block;
              width: 1px;
              height: 10px;
              background: #c0c4cc;
              position: absolute;
              left: 6px;
              bottom: -6px;
            }
          }

          .info-container {
            // flex: 1;
            margin-left: 8px;
            vertical-align: middle;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .info {
              vertical-align: middle;

              &::before {
                content: '';
                display: inline-block;
                width: 3px;
                height: 3px;
                margin: 0 8px 2px;
                border-radius: 50%;
                background: #606266;
                vertical-align: middle
              }

              &:first-child::before {
                display: none;
              }

              &:last-child::before {
                width: 0;
                height: 0;
                margin: 0 4px;
              }
            }
          }
        }
      }

    }

    .assessment-info {
      width: 258px;
      margin-left: 46px;
      margin-right: 20px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .score-line {
        margin-bottom: 6px;

        &:last-child {
          margin-bottom: 0;
        }

        .score {
          display: flex;
          line-height: 24px;
          color: #505d70;

          .score-label {
            margin-left: 0;
            margin-right: auto;
            font-size: 12px;
            color: #505d6f;
          }

          .score-number {
            margin-left: auto;
            margin-right: 0;
          }
        }

        .percent-line {
          height: 4px;
          border-radius: 4px;
          background: #f3f5f8;
          position: relative;

          .color-line {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
  }

.action-children-container {
  padding: 10px 0;

  .child-item {
    line-height: 36px;
    padding: 0 20px;
    margin: 0;
    cursor: pointer;

    &:hover {
      color: #0096cc;
      background-color: #ecf5ff;
    }
  }
}
</style>
